import React from 'react';

import NavigateButton from '../UI/Buttons/NavigateButton';

const Common = ({ children, headline, padding=true }) => {
  return (
    <div className="flex flex-col h-full text-start">
      <div className="flex justify-between pb-4">
        <h2 className=" text-3xl">{headline}</h2>
         <NavigateButton text='back' />
       </div>

      <div className={`flex-grow border-4 !border-[#E0F5FD] overflow-auto h-full ${padding ? 'p-4' : ''}`}>
        {/* Content area */}
        {children}
      </div>



    </div>
  );
};

export default Common;
